import { __read } from "tslib";
import React from 'react';
import { supportsPassive } from '../utils/browser/supportsPassiveEventListeners';
import { isBrowser } from '../utils/browser';
var getSize = function () { return ({
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
}); };
var LISTENER_OPTIONS = supportsPassive ? { passive: true } : false;
var useWindowSize = function () {
    var _a = __read(React.useState(isBrowser() ? getSize() : null), 2), windowSize = _a[0], setWindowSize = _a[1];
    var handleResize = function () {
        setWindowSize(getSize());
    };
    React.useEffect(function () {
        window.addEventListener('resize', handleResize, LISTENER_OPTIONS);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return windowSize;
};
export { useWindowSize };
//# sourceMappingURL=useWindowSize.js.map